export type ImageOptions = {
  width?: number;
  height?: number;
  circle?: boolean;
  quality?: number;
  progressive?: boolean;
};

// Same transformation segments the @cloudinary/url-gen SDK built, so existing derived assets stay cached.
export const cloudinaryUrl = (cloudName: string, publicId: string, options: ImageOptions = {}) => {
  const { width, height, circle, quality, progressive } = options;
  const scale =
    width || height ? ["c_scale", height && `h_${height}`, width && `w_${width}`].filter(Boolean).join(",") : null;
  const segments = [
    `q_${quality ?? "auto"}`,
    "f_auto",
    scale,
    circle && "r_max",
    progressive && "fl_progressive:steep",
    encodeURI(publicId),
  ];
  return `https://res.cloudinary.com/${cloudName}/image/upload/${segments.filter(Boolean).join("/")}`;
};
